import { convertToLocalDate, isBetween } from '@gig/magic-common';
import { magic } from '@gig/magic-sdk';
import Vue from 'vue';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const TRANSACTIONS_NAMESPACE = "TRANSACTIONS_NAMESPACE";
const SET_GAMING_TRANSACTIONS = "SET_GAMING_TRANSACTIONS";
const SET_PAYMENT_TRANSACTIONS = "SET_PAYMENT_TRANSACTIONS";
const SET_BONUSES_TRANSACTIONS = "SET_BONUSES_TRANSACTIONS";
const CACHE_TIME = 30 * 1e3;
const isCached = (timestamp) => {
  if (!timestamp) {
    return false;
  }
  return Date.now() - timestamp < CACHE_TIME;
};
const serializeDate = (from, to) => {
  return from.toISOString() + "~" + to.toISOString();
};
function serialiseHelper(key, innerKey, defaultValue) {
  return (state) => (from, to) => {
    const fromUtc = convertToLocalDate(from);
    const toUtc = convertToLocalDate(to);
    const dateKey = serializeDate(fromUtc, toUtc);
    if (state[key][dateKey] && state[key][dateKey][innerKey] !== void 0) {
      return state[key][dateKey][innerKey];
    }
    return defaultValue;
  };
}
const transactionsGetters = {
  getGameTransactionsFetchTime: serialiseHelper("gamesTransactions", "fetchTime", null),
  isGameTransactionsLoading: serialiseHelper("gamesTransactions", "isLoading", false),
  getGameTransactions: serialiseHelper("gamesTransactions", "transactions", []),
  getGameTransactionsPromise: serialiseHelper("gamesTransactions", "promise", Promise.resolve([])),
  getPaymentTransactionsFetchTime: serialiseHelper("paymentTransactions", "fetchTime", null),
  isPaymentTransactionsLoading: serialiseHelper("paymentTransactions", "isLoading", false),
  getPaymentTransactionsPromise: serialiseHelper("paymentTransactions", "promise", Promise.resolve([])),
  getPaymentTransactions: serialiseHelper("paymentTransactions", "transactions", []),
  getBonusesTransactionsFetchTime: serialiseHelper("bonusesTransactions", "fetchTime", null),
  isBonusesTransactionsLoading: serialiseHelper("bonusesTransactions", "isLoading", false),
  getBonusesTransactionsPromise: serialiseHelper("bonusesTransactions", "promise", Promise.resolve([])),
  getBonusesTransactions: serialiseHelper("bonusesTransactions", "transactions", [])
};
const transactionsActions = {
  fetchGamesTransactions(_0, _1) {
    return __async(this, arguments, function* ({ commit, getters }, { from, to }) {
      const fromUtc = convertToLocalDate(from);
      const toUtc = convertToLocalDate(to);
      const key = serializeDate(fromUtc, toUtc);
      if (isCached(getters.getGameTransactionsFetchTime(fromUtc, toUtc)) || getters.isGameTransactionsLoading(fromUtc, toUtc)) {
        return getters.getGameTransactionsPromise(fromUtc, toUtc);
      }
      const fetchTransactions = magic.methods.wallet.getGamesTransactions(fromUtc, toUtc).then((transactions2) => {
        transactions2 = transactions2.filter((t) => isBetween(new Date(t.date), convertToLocalDate(new Date(fromUtc)), new Date(toUtc)));
        commit(SET_GAMING_TRANSACTIONS, {
          key,
          isLoading: false,
          transactions: transactions2,
          fetchTime: Date.now()
        });
        return transactions2;
      }, (e) => {
        commit(SET_GAMING_TRANSACTIONS, {
          key,
          isLoading: false,
          transactions: [],
          fetchTime: 0
        });
        console.error(e);
      });
      commit(SET_GAMING_TRANSACTIONS, {
        key,
        isLoading: true,
        fetchTime: null,
        promise: fetchTransactions
      });
      return yield fetchTransactions;
    });
  },
  fetchPaymentTransactions(_0, _1) {
    return __async(this, arguments, function* ({ commit, getters }, { from, to }) {
      const fromUtc = convertToLocalDate(from);
      const toUtc = convertToLocalDate(to);
      const key = serializeDate(fromUtc, toUtc);
      if (isCached(getters.getPaymentTransactionsFetchTime(fromUtc, toUtc)) || getters.isPaymentTransactionsLoading(fromUtc, toUtc)) {
        return getters.getPaymentTransactionsPromise(fromUtc, toUtc);
      }
      const fetchTransactions = magic.methods.wallet.getTransactionHistory(fromUtc, toUtc).then((transactions2) => {
        transactions2 = transactions2.filter((t) => isBetween(new Date(t.date), convertToLocalDate(new Date(fromUtc)), new Date(toUtc)));
        commit(SET_PAYMENT_TRANSACTIONS, {
          key,
          isLoading: false,
          transactions: transactions2,
          fetchTime: Date.now()
        });
        return transactions2;
      }, (e) => {
        commit(SET_PAYMENT_TRANSACTIONS, {
          key,
          isLoading: false,
          transactions: [],
          fetchTime: 0
        });
        console.error(e);
      });
      commit(SET_PAYMENT_TRANSACTIONS, {
        key,
        isLoading: true,
        fetchTime: null,
        promise: fetchTransactions
      });
      return yield fetchTransactions;
    });
  },
  fetchBonusesTransactions(_0, _1) {
    return __async(this, arguments, function* ({ commit, getters }, { from, to }) {
      const fromUtc = convertToLocalDate(from);
      const toUtc = convertToLocalDate(to);
      const key = serializeDate(fromUtc, toUtc);
      if (isCached(getters.getBonusesTransactionsFetchTime(fromUtc, toUtc)) || getters.isBonusesTransactionsLoading(fromUtc, toUtc)) {
        return getters.getBonusesTransactionsPromise(fromUtc, toUtc);
      }
      const fetchTransactions = magic.methods.wallet.getBonusesHistory(fromUtc, toUtc).then((transactions2) => {
        transactions2 = transactions2.filter((t) => isBetween(new Date(t.dateCreated), convertToLocalDate(new Date(fromUtc)), new Date(toUtc))).reduce((previousValue, currentValue) => {
          const isDupplicated = previousValue.find((tra) => tra.userBonusId === currentValue.userBonusId);
          if (!previousValue.length) {
            return [currentValue];
          } else if (!isDupplicated) {
            previousValue.push(currentValue);
          }
          return previousValue;
        }, []);
        commit(SET_BONUSES_TRANSACTIONS, {
          key,
          isLoading: false,
          transactions: transactions2,
          fetchTime: Date.now()
        });
        return transactions2;
      }, (e) => {
        commit(SET_BONUSES_TRANSACTIONS, {
          key,
          isLoading: false,
          transactions: [],
          fetchTime: 0
        });
        console.error(e);
      });
      commit(SET_BONUSES_TRANSACTIONS, {
        key,
        isLoading: true,
        fetchTime: null,
        promise: fetchTransactions
      });
      return yield fetchTransactions;
    });
  }
};
const transactions = {
  namespaced: true,
  state: {
    gamesTransactions: {},
    paymentTransactions: {},
    bonusesTransactions: {}
  },
  getters: transactionsGetters,
  actions: transactionsActions,
  mutations: {
    [SET_GAMING_TRANSACTIONS]: (state, payload) => {
      Vue.set(state.gamesTransactions, payload.key, __spreadValues(__spreadValues({}, state.gamesTransactions[payload.key]), payload));
    },
    [SET_PAYMENT_TRANSACTIONS]: (state, payload) => {
      Vue.set(state.paymentTransactions, payload.key, __spreadValues(__spreadValues({}, state.paymentTransactions[payload.key]), payload));
    },
    [SET_BONUSES_TRANSACTIONS]: (state, payload) => {
      Vue.set(state.bonusesTransactions, payload.key, __spreadValues(__spreadValues({}, state.bonusesTransactions[payload.key]), payload));
    }
  }
};

export { SET_BONUSES_TRANSACTIONS, SET_GAMING_TRANSACTIONS, SET_PAYMENT_TRANSACTIONS, TRANSACTIONS_NAMESPACE, transactions, transactionsActions, transactionsGetters };
